import request from 'api/request';

export default function archiveCourse(id) {
  return request({ url: `/courses/${id}/archive`, method: 'POST' });
}
